/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Api Documentation
 * Api Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  CreateUserEnvRequest,
  DeleteV8UserEnvsParams,
  GetV8UserEnvsParams,
  PostV8UserEnvsParams,
  UserEnvResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 사용자 환경 조회
 */
export const getV8UserEnvs = (
  params?: MaybeRef<GetV8UserEnvsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<UserEnvResponse>(
    { url: `/api/v8/user-envs`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8UserEnvsQueryKey = (params?: MaybeRef<GetV8UserEnvsParams>) => {
  return ['api', 'v8', 'user-envs', ...(params ? [params] : [])] as const;
};

export const getGetV8UserEnvsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8UserEnvs>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8UserEnvsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8UserEnvs>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8UserEnvsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8UserEnvs>>> = ({ signal }) =>
    getV8UserEnvs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8UserEnvs>>,
    TError,
    TData
  >;
};

export type GetV8UserEnvsQueryResult = NonNullable<Awaited<ReturnType<typeof getV8UserEnvs>>>;
export type GetV8UserEnvsQueryError = ErrorType<unknown>;

/**
 * @summary 사용자 환경 조회
 */

export function useGetV8UserEnvs<
  TData = Awaited<ReturnType<typeof getV8UserEnvs>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8UserEnvsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8UserEnvs>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8UserEnvsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 사용자 환경 등록
 */
export const postV8UserEnvs = (
  createUserEnvRequest: MaybeRef<CreateUserEnvRequest[]>,
  params?: MaybeRef<PostV8UserEnvsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  createUserEnvRequest = unref(createUserEnvRequest);
  params = unref(params);

  return customAxiosInstance<string>(
    {
      url: `/api/v8/user-envs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUserEnvRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8UserEnvsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8UserEnvs>>,
    TError,
    { data: BodyType<CreateUserEnvRequest[]>; params?: PostV8UserEnvsParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8UserEnvs>>,
  TError,
  { data: BodyType<CreateUserEnvRequest[]>; params?: PostV8UserEnvsParams },
  TContext
> => {
  const mutationKey = ['postV8UserEnvs'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8UserEnvs>>,
    { data: BodyType<CreateUserEnvRequest[]>; params?: PostV8UserEnvsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8UserEnvs(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8UserEnvsMutationResult = NonNullable<Awaited<ReturnType<typeof postV8UserEnvs>>>;
export type PostV8UserEnvsMutationBody = BodyType<CreateUserEnvRequest[]>;
export type PostV8UserEnvsMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 환경 등록
 */
export const usePostV8UserEnvs = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8UserEnvs>>,
      TError,
      { data: BodyType<CreateUserEnvRequest[]>; params?: PostV8UserEnvsParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8UserEnvs>>,
  TError,
  { data: BodyType<CreateUserEnvRequest[]>; params?: PostV8UserEnvsParams },
  TContext
> => {
  const mutationOptions = getPostV8UserEnvsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 환경 삭제
 */
export const deleteV8UserEnvs = (
  params: MaybeRef<DeleteV8UserEnvsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<string>(
    { url: `/api/v8/user-envs`, method: 'DELETE', params: unref(params) },
    options,
  );
};

export const getDeleteV8UserEnvsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV8UserEnvs>>,
    TError,
    { params: DeleteV8UserEnvsParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV8UserEnvs>>,
  TError,
  { params: DeleteV8UserEnvsParams },
  TContext
> => {
  const mutationKey = ['deleteV8UserEnvs'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV8UserEnvs>>,
    { params: DeleteV8UserEnvsParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV8UserEnvs(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV8UserEnvsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV8UserEnvs>>
>;

export type DeleteV8UserEnvsMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 환경 삭제
 */
export const useDeleteV8UserEnvs = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV8UserEnvs>>,
      TError,
      { params: DeleteV8UserEnvsParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV8UserEnvs>>,
  TError,
  { params: DeleteV8UserEnvsParams },
  TContext
> => {
  const mutationOptions = getDeleteV8UserEnvsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
